import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Quote} from '../models/quote.interface';
import {EstimateDateOption} from "../models/estimate-date-option.interface";
import {QuoteInfo} from "../models/quote-info.interface";
import {ProjectDocument} from "../models/project-document.interface";

@Injectable({
	providedIn: 'root'
})
export class QuoteService {
	baseUrl: string = `${environment.url}/quote`;
  private dateRangeOptions: EstimateDateOption[] = [];

	constructor(private http: HttpClient) {
    this.createDateRangeOptions();
  }

	findOne(id: number): Observable<Quote> {
		return this.http.get<Quote>(`${this.baseUrl}/${id}`);
	}

	getQuoteInfo(id: number): Observable<QuoteInfo> {
    return this.http.get<QuoteInfo>(`${this.baseUrl}/${id}/pdf`);
  }

  findOneQuoteDocument(id: number, document: ProjectDocument): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}/document/${document.id}`);
  }

  submitApproval(id: number, formData: FormData): Observable<QuoteInfo> {
    return this.http.post<QuoteInfo>(`${this.baseUrl}/${id}/approve`, formData);
  }

  requestChanges(quoteId: number, formData: FormData): Observable<QuoteInfo> {
    return this.http.post<QuoteInfo>(`${this.baseUrl}/${quoteId}/change-request`, formData);
  }

  getDateRangeOptions(): EstimateDateOption[] {
    return this.dateRangeOptions;
  }

  createDateRangeOptions(): void {
    let now: Date = new Date();
    const currentMonth: number = now.getMonth();
    //If the date is > 15, set it to the 1st so that first half of month still an option
    now.setHours(0, 0, 0, 0);
    if (now.getUTCDate() < 15) {
      now.setDate(1);
    }

    this.dateRangeOptions.push({
      date: {} as Date,
      description: 'Unknown'
    });

    for (let i = currentMonth; i < currentMonth + 12; i++) {
      const targetMonth: number = i % 12;
      const targetYear: number = now.getFullYear() + Math.floor(i / 12);

      const firstOfMonth: Date = new Date(targetYear, targetMonth, 1);
      const fifteenthOfMonth: Date = new Date(targetYear, targetMonth, 16);

      if (now <= firstOfMonth) {
        this.dateRangeOptions.push({
          date: firstOfMonth,
          description: firstOfMonth.toLocaleString('default', {month: 'long'}) + ' - First Half'
        });
      }
      if (now <= fifteenthOfMonth) {
        this.dateRangeOptions.push({
          date: fifteenthOfMonth,
          description: firstOfMonth.toLocaleString('default', {month: 'long'}) + ' - Second Half'
        });
      }
    }
  }
}
